import React from 'react';
import { AdapterGenerico } from '../../../../shared/Infraestructure/AdapterGenerico';
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate';
import { EntityMain } from '../../Domain/EntityMain';
import { EntityModeMultipleSelect } from '../../Domain/EntityModeMultipleSelect';
import { EntityComparative } from '../../../../shared/Domain/EntityComparative';

interface ContainerProps {
    data: EntityMain<EntityComparative>[];
    monedaSymbols: { [code: string]: string };
    onRedirectForm(id: string): any;
    show: boolean;
    copyCodeItem: (code: string) => Promise<void>;
    onSelectItem: (code: string) => void;
    modeMultipleSelect: EntityModeMultipleSelect;
}

const avatarColors = ['#4C6FFF', '#0E9F86', '#E8622C', '#0B2A5B', '#8B5CF6'];
const countryBadgeColors: { [key: string]: { bg: string; text: string } } = {
    PE: { bg: '#FCE7DA', text: '#C2540E' },
    CO: { bg: '#FBF1CB', text: '#A67C05' },
};
const defaultCountryBadgeColor = { bg: '#E9ECF2', text: '#4B5566' };

export const ViewComparativo = (props: ContainerProps) => {
    if (!props.show) return null;
    const languageTranslate = LanguageTranslate();
    return (
        <div className="row pt-3 mb-5">
            <div className="col-12 mb-5">
                {
                    props.data.map((row, index) => {
                        if (props.modeMultipleSelect.active && row.isPendingSend) return null;
                        const badgeColor = row.Pais?.Code ? (countryBadgeColors[row.Pais.Code] || defaultCountryBadgeColor) : defaultCountryBadgeColor;
                        console.log(row);
                        return (
                            <div className="row pb-3 ItemGenericList" key={row._id}>
                                <div className="col-12">
                                    <div className={`ComparativeCard shadow-sm position-relative ${row.isPendingSend ? 'pending' : ''}`}>
                                        <div className={`${props.modeMultipleSelect.active ? 'ModeSelectItem' : ''} ${props.modeMultipleSelect.listCode.includes(row.Codigo) ? 'ModeSelectItem-select' : ''}`} onClick={() => props.onSelectItem(row.Codigo)} />

                                        <div className="ComparativeCard-header" onClick={() => props.onRedirectForm(row._id)}>
                                            <div className="ComparativeCard-avatar" style={{ backgroundColor: avatarColors[index % avatarColors.length] }}>
                                                {row.Pais?.Code}
                                            </div>
                                            <div className="ComparativeCard-headerInfo">
                                                <div className="ComparativeCard-code" onClick={(evt) => { evt.stopPropagation(); props.copyCodeItem(row.Codigo); }}>
                                                    <span>{row.Codigo}</span>
                                                    <button className='icon-copy-custom'><i className="fa-solid fa-copy" /></button>
                                                </div>
                                                <div className="ComparativeCard-proveedor">{row.Proveedor}</div>
                                            </div>
                                            {
                                                row.Pais?.Name &&
                                                <span className="ComparativeCard-countryBadge" style={{ backgroundColor: badgeColor.bg, color: badgeColor.text }}>{row.Pais.Name}</span>
                                            }
                                        </div>

                                        {
                                            row.Descripcion &&
                                            <div className="ComparativeCard-descripcion" onClick={() => props.onRedirectForm(row._id)}>{row.Descripcion}</div>
                                        }

                                        <div className="ComparativeCard-divider" />

                                        <div className="ComparativeCard-footer" onClick={() => props.onRedirectForm(row._id)}>
                                            <div className="ComparativeCard-footerLeft">
                                                <span className="ComparativeCard-footerLabel">{languageTranslate.moduloGenericList.item.itemTextFechaRegistro}</span>
                                                <span className="ComparativeCard-footerDate">{AdapterGenerico.convertDateToString(row.FechaRegistro, 3)}</span>
                                            </div>
                                            <div className="ComparativeCard-footerRight">
                                                { row.Global || row.Multiproveedor ?
                                                    <div className="GroupBadge">
                                                        { row.Global ? <div className="badgeCustom badgeCustom-global"><i className="fa-solid fa-file-contract" /> </div> : null }
                                                        { row.Multiproveedor ? <div className="badgeCustom badgeCustom-multiproveedor"><i className="fa-solid fa-users" ></i></div> : null }
                                                    </div>
                                                : null }
                                                <span className="ComparativeCard-amount">{props.monedaSymbols[row.MonedaCodigo || ''] || '$'} {AdapterGenerico.formatoDinero(row.Importe)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}